module.exports = "/_next/static/images/fallback_S-18ed5e97dec20f4aaaa53a39476dfb09.png";